module.exports = __webpack_public_path__ + "media/images/proof_links/vimeo-fbb16ed3e013a7f4062da3f67cd5afa6.svg";